import { EmptyObject } from 'types/empty';
import { MediaPlaybackProvider } from 'modules/Canvas/contexts/MediaProvider/MediaPlayback';
import { MediaStateProvider } from 'modules/Canvas/contexts/MediaProvider/MediaState';

export function MediaProvider({ children }: React.PropsWithChildren<EmptyObject>): JSX.Element {
  return (
    <MediaStateProvider>
      <MediaPlaybackProvider>{children}</MediaPlaybackProvider>
    </MediaStateProvider>
  );
}
